import { EmptyObject } from '../EmptyObject';

export const ShowOSDRequest = 'sos.Monitoring.OSD.ShowOSDRequest';
export interface ShowOSDRequest {
	type: typeof ShowOSDRequest;
}

export const ShowOSDResult = 'sos.Monitoring.OSD.ShowOSDResult';
export interface ShowOSDResult {
	type: typeof ShowOSDResult;
	result: EmptyObject;
}
